<template>
  <li
    :is="notification.type"
    :notification="notification"
    :class="{ 'super-admin--unauthorized': notification.text.includes('unauthorized') }"
    @close="closeNotification"
  />
</template>

<script type="text/babel">
import Success from './notification-types/Success.vue'
import Warning from './notification-types/Warning.vue'
import Error from './notification-types/Error.vue'
import Note from './notification-types/Note.vue'

export default {
  name: 'Notification',
  components: {
    error: Error,
    success: Success,
    warning: Warning,
    note: Note,
    danger: Error,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
    }
  },
  computed: {
    hidesAutomatically() {
      return _.get(this.notification, 'timeout', true)
    },
  },
  async mounted() {
    await this.$nextTick()

    if (this.hidesAutomatically) {
      const delay = _.get(this.notification, 'delay', 8000)

      this.timer = setTimeout(() => {
        this.closeNotification()
      }, delay)
    }
  },
  methods: {
    closeNotification() {
      clearTimeout(this.timer)

      this.$store.commit('baseRemoveNotification', this.notification)
    },
  },
}
</script>
